import { Outlet, Route, Routes } from "react-router-dom";
import { WrappedLayout } from "./layout/WrappedLayout";
import { Allowance } from "./page/Allowance";
import { Connect } from "./page/Connect";
import { Dashboard } from "./page/Dashboard";
import { Setting } from "./page/Setting";
import { Staking } from "./page/Staking";

export function Body() {
  return (
    <Routes>
      <Route>
        <Route path="/" element={<Connect />} />
      </Route>
      <Route
        element={
          <WrappedLayout>
            <Outlet />
          </WrappedLayout>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/setting" element={<Setting />} />
        <Route path="/staking/:apy" element={<Staking />} />
        <Route path="/allowance/:apy" element={<Allowance />} />
      </Route>
    </Routes>
  );
}
